module.exports = __webpack_public_path__ + "img/grey-network.071f65d0.png";